import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-mt-3" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-4 p-mb-3" }
const _hoisted_4 = { class: "p-float-label" }
const _hoisted_5 = {
  for: "word",
  class: "kn-material-input-label"
}
const _hoisted_6 = { class: "p-field p-col-4" }
const _hoisted_7 = { class: "p-float-label" }
const _hoisted_8 = {
  for: "status",
  class: "kn-material-input-label"
}
const _hoisted_9 = { class: "p-field p-col-4" }
const _hoisted_10 = { class: "p-float-label" }
const _hoisted_11 = {
  for: "category",
  class: "kn-material-input-label"
}
const _hoisted_12 = { class: "p-field p-col-12" }
const _hoisted_13 = { class: "p-float-label" }
const _hoisted_14 = {
  for: "description",
  class: "kn-material-input-label"
}
const _hoisted_15 = { class: "p-field p-col-12" }
const _hoisted_16 = { class: "p-float-label" }
const _hoisted_17 = {
  for: "formula",
  class: "kn-material-input-label"
}
const _hoisted_18 = { class: "p-field p-col-12" }
const _hoisted_19 = { class: "p-float-label" }
const _hoisted_20 = {
  for: "link",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_AutoComplete = _resolveComponent("AutoComplete")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: _ctx.$tc('managers.glossary.common.word', 1),
    breakpoints: _ctx.glossaryDefinitionDialogDescriptor.dialog.breakpoints,
    style: _ctx.glossaryDefinitionDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false,
    class: "p-fluid kn-dialog--toolbar--primary"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: _ctx.$t('common.cancel'),
        onClick: _ctx.closeDialog,
        class: "kn-button kn-button--secondary"
      }, null, 8, ["label", "onClick"]),
      _createVNode(_component_Button, {
        label: _ctx.$t('common.save'),
        onClick: _ctx.saveWord,
        class: "kn-button kn-button--primary",
        disabled: _ctx.buttonDisabled
      }, null, 8, ["label", "onClick", "disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("form", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("span", _hoisted_4, [
              _createVNode(_component_InputText, {
                id: "word",
                class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.word.WORD.$invalid && _ctx.v$.word.WORD.$dirty
                            }],
                type: "text",
                modelValue: _ctx.v$.word.WORD.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.word.WORD.$model = $event)),
                modelModifiers: { trim: true },
                maxLength: "100",
                onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.word.WORD.$touch()))
              }, null, 8, ["modelValue", "class"]),
              _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('managers.glossary.common.word', 1)) + " * ", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              class: "p-mt-1",
              vComp: _ctx.v$.word.WORD,
              additionalTranslateParams: { fieldName: _ctx.$tc('managers.glossary.common.word', 1) }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("span", _hoisted_7, [
              _createVNode(_component_Dropdown, {
                id: "status",
                class: "kn-material-input",
                modelValue: _ctx.word.STATE,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.word.STATE = $event)),
                options: _ctx.tState,
                optionValue: "id",
                optionLabel: "name"
              }, null, 8, ["modelValue", "options"]),
              _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('managers.glossary.common.status')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("span", _hoisted_10, [
              _createVNode(_component_Dropdown, {
                id: "category",
                class: "kn-material-input",
                modelValue: _ctx.word.CATEGORY,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.word.CATEGORY = $event)),
                options: _ctx.tCategory,
                optionValue: "id",
                optionLabel: "name"
              }, null, 8, ["modelValue", "options"]),
              _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('common.category')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode("span", _hoisted_13, [
              _createVNode(_component_InputText, {
                id: "description",
                class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.word.DESCR.$invalid && _ctx.v$.word.DESCR.$dirty
                            }],
                type: "text",
                modelValue: _ctx.v$.word.DESCR.$model,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.word.DESCR.$model = $event)),
                maxLength: "500",
                onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.word.DESCR.$touch()))
              }, null, 8, ["modelValue", "class"]),
              _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('common.description')) + " *", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              class: "p-mt-1",
              vComp: _ctx.v$.word.DESCR,
              additionalTranslateParams: { fieldName: _ctx.$t('common.description') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ]),
          _createVNode("div", _hoisted_15, [
            _createVNode("span", _hoisted_16, [
              _createVNode(_component_InputText, {
                id: "formula",
                class: "kn-material-input",
                type: "text",
                modelValue: _ctx.word.FORMULA,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.word.FORMULA = $event)),
                maxLength: "500"
              }, null, 8, ["modelValue"]),
              _createVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('managers.glossary.common.formula')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_18, [
            _createVNode("span", _hoisted_19, [
              _createVNode(_component_AutoComplete, {
                id: "link",
                class: "kn-material-input",
                multiple: true,
                modelValue: _ctx.word.LINK,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.word.LINK = $event)),
                suggestions: _ctx.availableWords,
                onComplete: _cache[9] || (_cache[9] = ($event: any) => (_ctx.searchWord($event))),
                field: "WORD"
              }, null, 8, ["modelValue", "suggestions"]),
              _createVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('managers.glossary.common.link')), 1)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["header", "breakpoints", "style", "visible"]))
}